const HeaderNavigation = () => ({
  didResolveSizes: false,
  containerWidth: 0,
  linksWidth: 0,
  get shouldHeaderCollapse() {
    return this.didResolveSizes && !this.linksFitWithinContainer;
  },
  get linksFitWithinContainer() {
    return Number(this.linksWidth.toFixed(3)) <= Number(this.containerWidth.toFixed(3));
  },
  init() {
    const container = this.$el.querySelector(".header__linklist");
    const links = [...container.querySelectorAll(".header__linklist-item")];
    this.linksWidth =
      links.reduce((acc, item) => acc + Number(item.getBoundingClientRect().width.toFixed(3)) + 32, 0) - 33;

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (!entry.target.matches(".header__linklist")) return;

        const { width } = entry.target.getBoundingClientRect();

        this.containerWidth = Number(width.toFixed(3));
        this.linksWidth =
          links.reduce((acc, item) => acc + Number(item.getBoundingClientRect().width.toFixed(3)) + 32, 0) - 33;
        this.didResolveSizes = true;
      }
    });

    resizeObserver.observe(container);
  }
});

export default HeaderNavigation;
